import { vendorCodeFromLink } from './vendorLinks';
import { ANDROID_STORE, IOS_STORE, vendorDevice } from './vendorGateway';
import type { RoutingFlags, VendorDevice } from './vendorGateway';

export interface NativeEntryContext {
	code: string | null;
	device: VendorDevice;
	nativeReady: boolean;
}

/** A build gate, not an authentication or API access control. */
export function nativeEntryContext(
	href: string, userAgent: string, touchPoints: number,
	native: boolean, enabled: boolean, flags: RoutingFlags,
): NativeEntryContext | null {
	if (!enabled || native) return null;
	const url = new URL(href);
	// Demo and unrelated hosts keep their own entry points. Loopback is for offline QA.
	if (!['app.scandeckapp.com', 'localhost', '127.0.0.1'].includes(url.hostname)) return null;
	const device = vendorDevice(userAgent, touchPoints);
	return {
		code: vendorCodeFromLink(`https://app.scandeckapp.com${url.pathname}${url.search}${url.hash}`),
		device,
		nativeReady: device === 'ios' ? flags.ios : device === 'android' ? flags.android : false,
	};
}

export function nativeEntryLink(code: string | null, native = false): string {
	const base = native ? 'scandeck://vendor' : 'https://app.scandeckapp.com/open';
	return code ? `${base}?v=${encodeURIComponent(code)}` : base;
}

/** Where a browser visit without a vendor code goes. The marketing page carries the install content. */
export const MARKETING_APP_PAGE = 'https://scandeckapp.com/trade-show-badge-scanner/';

/**
 * Browser visits without a vendor code have nothing app specific to show, so they
 * leave for the marketing Lead Capture page. A fixed destination also drops any
 * query or fragment the visitor arrived with. Card links with a code stay here.
 */
export function nativeEntryRedirect(context: NativeEntryContext): string | null {
	return context.code ? null : MARKETING_APP_PAGE;
}

export function nativeEntryStore(context: NativeEntryContext): string | null {
	if (!context.nativeReady) return null;
	return context.device === 'ios' ? IOS_STORE : context.device === 'android' ? ANDROID_STORE : null;
}
